/**
 * Categoria: Avaliações Técnicas (Operação)
 * O dia a dia dos professores ao avaliarem alunos durante as aulas.
 */
export const AVALIACOES_TECNICAS = {
    id: "avaliacao_alunos",
    title: "Avaliações Técnicas (Operação)",
    icon: "ph-light ph-clipboard-text",
    description: "O dia a dia dos professores ao avaliarem alunos durantes as aulas.",
    steps: [
        {
            id: "av_fase1",
            title: "Fase 1 — Rotina de Avaliação em Aula",
            description: "Presumindo que os pré-requisitos (Turma e Evento Ativo) estejam cumpridos, esta é a vida do professor:",
            subItems: [
                {
                    id: "av_turmas",
                    icon: "ph-light ph-list-dashes",
                    title: "Acessar Turmas do Dia",
                    content: `<p class="mb-0"><strong>O que ele faz:</strong> O professor com seu respectivo login acessa <strong>Técnico > Avaliações</strong>. O sistema filtra e lista instantaneamente as turmas onde ele está alocado como professor no dia de hoje.</p>`
                },
                {
                    id: "av_notas",
                    icon: "ph-light ph-crosshair",
                    title: "Atribuir Notas por Habilidade",
                    content: `<p class="mb-0"><strong>O que ele faz:</strong> Entra na turma listada, abre os Tópicos a serem testados e, para cada criança da lista de chamada presente, concede o Nível (Ex: "Excelente") atingido. O App salva o <em>rascunho offline</em>.</p>`
                },
                {
                    id: "av_salvar",
                    icon: "ph-light ph-floppy-disk",
                    title: "Oficializar Avaliações",
                    content: `<p class="mb-0"><strong>Atenção:</strong> Para publicar as notas pro sistema processar, o professor clica em <strong>"Salvar Avaliações"</strong>. As notas vão para o banco de dados e as mágicas de progressão podem acontecer.</p>`
                }
            ]
        },
        {
            id: "av_fase2",
            title: "Fase 2 — Gamificação, XP e Aprovação do Aluno",
            description: "O que acontece assim que o professor confirma o 'Salvar' das notas:",
            subItems: [
                {
                    id: "av_desempenho",
                    icon: "ph-light ph-chart-line-up",
                    title: "Cálculo de Desempenho",
                    content: `<p class="mb-0">O sistema checa os níveis ganhos em comparação aos limites estipulados para a modalidade, calculando uma porcentagem exata de domínio da atividade (Ex: Acertou 80% dos requisitos).</p>`
                },
                {
                    id: "av_xp",
                    icon: "ph-light ph-diamond",
                    title: "Gamificação e Pontos de XP Parciais",
                    content: `<p class="mb-0">Se algum aluno teve "nota máxima" em uma técnica (Tópico) que vale XP, o sistema entrega os pontos de XP instantaneamente a ele. Mas atenção: o sistema é imune a fraudes de XP. Se o professor desmarcar a nota e tentar dar nota máxima de novo na próxima semana, o XP não será concedido em duplicidade para a mesma tarefa.</p>`
                },
                {
                    id: "av_aprovacao",
                    icon: "ph-light ph-medal",
                    title: "Aprovação (Troca de Nível / Faixa)",
                    content: `<p class="mb-2">Para o App alterar o status do aluno como <strong>"Aprovado"</strong> (pronto para a próxima turma), dois fatores são validados simultaneamente:</p>
                              <ul>
                                  <li class="mb-1">Somatório de acertos: Ele superou a porcentagem mínima de proficiência configurada?</li>
                                  <li><strong>Regra do Tópico Fundamental:</strong> Ele tirou nota "Máxima" incondicionalmente em <strong>todos</strong> os tópicos configurados como fundamentais pela coordenação? (Se faltar 1 tópico fundamental apenas, ele é automaticamente retido, independente da alta porcentagem).</li>
                              </ul>`
                }
            ]
        }
    ]
};
